module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BlackItalic.ca0cd189.woff2";